import styled from 'styled-components';
import {
  BodySmall,
  ParagraphSmallText,
} from '../../../../../../../components/Texts';
import { Label } from '../../../../../../../components/Inputs/Text';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../../../../common/responsive';

const PaymentMethodContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;

const PaymentMethodButton = styled.button`
  flex: 1;
  height: 62px;
  border-radius: 16px;
  border: 1px solid
    ${(props) =>
      props.$active
        ? `${props.theme.primary.primary}`
        : `${props.theme.border.primary}`};
  padding: 12px 12px;
  background-color: ${(props) =>
    props.$active
      ? `${props.theme.background.primary}`
      : `${props.theme.background.light}`};
  font-weight: 600;
  font-size: 16px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      border-color: ${(props) =>
        props.$active
          ? `${props.theme.primary.primary}`
          : `${props.theme.text.disabled}`};
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const PaymentMethodTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const PaymentMethodText = styled(ParagraphSmallText)`
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  color: ${({ theme }) => theme.text.title};
`;

const PaymentMethodSubtext = styled(BodySmall)`
  color: ${({ theme }) => theme.text.regular};
  text-align: left;
`;

const DeliveryMethods = ({ handleDeliveryMethodChange, delivery }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  return (
    <div style={{ width: '100%' }}>
      <Label>Delivery Method</Label>
      <PaymentMethodContainer>
        <PaymentMethodButton
          $active={delivery === 'link'}
          onClick={() => handleDeliveryMethodChange('link')}
        >
          {!isMobile && <img src='/link.svg' alt='Link' />}
          <PaymentMethodTextContainer>
            <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              {isMobile && <img src='/link.svg' alt='Link' />}
              <PaymentMethodText>Shareable Link</PaymentMethodText>
            </div>
            <PaymentMethodSubtext>Send via a link</PaymentMethodSubtext>
          </PaymentMethodTextContainer>
        </PaymentMethodButton>
        <PaymentMethodButton
          $active={delivery === 'email'}
          onClick={() => handleDeliveryMethodChange('email')}
        >
          {!isMobile && <img src='/message.svg' alt='Email' />}
          <PaymentMethodTextContainer>
            <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              {isMobile && <img src='/message.svg' alt='Email' />}
              <PaymentMethodText>Email</PaymentMethodText>
            </div>
            <PaymentMethodSubtext>
              Send to an email address
            </PaymentMethodSubtext>
          </PaymentMethodTextContainer>
        </PaymentMethodButton>
      </PaymentMethodContainer>
    </div>
  );
};

export default DeliveryMethods;
